import apiClient from '../middleware/apiClient';
import { SSM_NOW_WALLET_INSTRUMENTS } from '../helpers/apis';
import { COTTON_SSM_NOW_WALLET_INSTRUMENTS } from '../helpers/cottonApis';
import { isCottonSession as getCottonSession } from '../helpers/featureFlags/cotton';

export const GET_NOW_INSTRUMENTS = 'GET_NOW_INSTRUMENTS';
export const GET_NOW_INSTRUMENTS_SUCCESS = 'GET_NOW_INSTRUMENTS_SUCCESS';
export const GET_NOW_INSTRUMENTS_FAILURE = 'GET_NOW_INSTRUMENTS_FAILURE';

function dispatchGetNowInstruments(isCottonSession = false) {
  const endpoint = isCottonSession ? COTTON_SSM_NOW_WALLET_INSTRUMENTS : SSM_NOW_WALLET_INSTRUMENTS;
  return {
    type: GET_NOW_INSTRUMENTS,
    payload: apiClient.fetch(endpoint),
  };
}

function dispatchGetNowInstrumentsSuccess(nowInstruments) {
  return {
    type: GET_NOW_INSTRUMENTS_SUCCESS,
    payload: nowInstruments,
  };
}

function dispatchGetNowInstrumentsFailure(error) {
  return {
    type: GET_NOW_INSTRUMENTS_FAILURE,
    payload: error,
  };
}


export const getNowInstruments = () => async (dispatch) => {
  try {
    const isCottonSession = getCottonSession();
    const response = await dispatch(dispatchGetNowInstruments(isCottonSession)).payload;
    return dispatch(dispatchGetNowInstrumentsSuccess(response));
  } catch (error) {
    dispatch(dispatchGetNowInstrumentsFailure(error));
    throw error;
  }
};
